/**
 * Left-edge newsletter tab: open/close panel, dismiss persists in localStorage.
 */
(function () {
  var KEY = 'sgg_newsletter_float_dismissed';
  var root = document.querySelector('[data-sgg-nl-float]');
  if (!root || root.hasAttribute('hidden')) return;

  var tab = root.querySelector('.sgg-nl-float__tab');
  var panel = root.querySelector('.sgg-nl-float__panel');
  var closeBtn = root.querySelector('[data-sgg-nl-close]');
  var dismissBtn = root.querySelector('[data-sgg-nl-dismiss]');
  var backdrop = root.querySelector('[data-sgg-nl-backdrop]');
  var successNotice = root.querySelector('.sgg-nl-float__success');
  var autoOpen = root.getAttribute('data-sgg-nl-auto-open') === '1';
  var autoOpenTimer = null;
  var successTimer = null;

  function setOpen(open) {
    root.classList.toggle('is-open', open);
    if (tab) tab.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open && panel) {
      var input = panel.querySelector('.sgg-nl-float__input');
      if (input) {
        window.setTimeout(function () {
          input.focus();
        }, 200);
      } else {
        panel.focus();
      }
    }
  }

  function cancelAutoOpen() {
    if (autoOpenTimer) {
      window.clearTimeout(autoOpenTimer);
      autoOpenTimer = null;
    }
  }

  function cancelSuccessAutoHide() {
    if (successTimer) {
      window.clearTimeout(successTimer);
      successTimer = null;
    }
  }

  function hideRoot() {
    cancelSuccessAutoHide();
    root.setAttribute('hidden', '');
    root.classList.remove('is-open');
  }

  if (tab) {
    tab.addEventListener('click', function () {
      cancelAutoOpen();
      cancelSuccessAutoHide();
      setOpen(!root.classList.contains('is-open'));
    });
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      cancelAutoOpen();
      cancelSuccessAutoHide();
      setOpen(false);
    });
  }

  if (backdrop) {
    backdrop.addEventListener('click', function () {
      cancelAutoOpen();
      cancelSuccessAutoHide();
      setOpen(false);
    });
  }

  if (dismissBtn) {
    dismissBtn.addEventListener('click', function () {
      cancelAutoOpen();
      cancelSuccessAutoHide();
      if (root.getAttribute('data-sgg-design-mode') !== '1') {
        localStorage.setItem(KEY, '1');
      }
      hideRoot();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) {
      cancelAutoOpen();
      cancelSuccessAutoHide();
      setOpen(false);
    }
  });

  if (successNotice) {
    setOpen(true);
    if (root.getAttribute('data-sgg-design-mode') !== '1') {
      successTimer = window.setTimeout(function () {
        hideRoot();
      }, 5200);
    }
  }

  if (autoOpen && root.getAttribute('data-sgg-design-mode') !== '1') {
    autoOpenTimer = window.setTimeout(function () {
      if (!root.classList.contains('is-open') && !root.hasAttribute('hidden')) {
        setOpen(true);
      }
    }, 4500);
  }
})();
